import * as types from '../actions/action-types';

export function collection(state = {apps: [], isFetchingApps: false, data: {}, isFetchingData: false}, action) {
  switch (action.type) {

    case types.REQUEST_COLLECTION:
      return {...state, isFetchingData: true, vertical: action.vertical};

    case types.RECEIVE_COLLECTION:
      return {...state, data: action.data, dataReceivedAt: action.receivedAt, isFetchingData: false};

    case types.REQUEST_COLLECTION_APPS:
      return {...state, isFetchingApps: true};

    case types.RECEIVE_COLLECTION_APPS:
      return {...state, apps: action.items, appsReceivedAt: action.receivedAt, isFetchingApps: false};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/collection.js